import React from "react";
import styles from "./form.module.css"

const CharacterCounter = ({ value = "", limit }) => {
    const length = `${value || ""}`.length

    if (!limit) return null

    return (
        <span className={`${styles.characterCounter} ${length >= limit ? styles.characterCounterLimit : ""}`}>
            {length}/{limit}
        </span>
    )
}

export default CharacterCounter
